module.exports = __webpack_public_path__ + "static/media/EXPLORE ON WHEELS SMALL.6ed271be.png";